import { ScrollSpy } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';

import { EarningsLivePrice } from '../earnings-live-price/EarningsLivePrice';
import * as S from './Sidebar.styles';
import { useSidebarItems } from './useSidebarItems';

export const Sidebar = ({
  entityData,
  containerRef,
}: {
  entityData?: Entity;
  containerRef: React.RefObject<HTMLElement | null>;
}) => {
  const { previewItems } = useSidebarItems();

  return (
    <S.SidebarContainer>
      {entityData && <EarningsLivePrice entity={entityData} />}
      <ScrollSpy items={previewItems} containerRef={containerRef} />
    </S.SidebarContainer>
  );
};
